import "./App.css";
import React from "react";
import { Route, Routes, BrowserRouter as Router } from "react-router-dom";
import { ProvideAuth } from "./Utils/Auth";
import { AdminLayout } from "./Layout/AdminSidebar/AdminSidebar";

import AdminLogin from "./Components/Admin/AdminLogin";
import AdminDashboard from "./Components/Admin/AdminDashboard";
import NonVerifyFounders from "./Components/Admin/NonVerifyFounders";
import NonVerifyInvestors from "./Components/Admin/NonVerifyInvestors";
import AllInvestors from "./Components/Admin/AllInvestors";
import NonverifyFounderPage from "./Components/Admin/NonVerifyFounderPage";
import NonverifyInvestorPage from "./Components/Admin/NonVerifyInvestorPage";
import NonverifyFundCompanies from "./Components/Admin/NonVerifyFundCompanies";
import NonverifyFundCompanyPage from "./Components/Admin/NonVerifyFundCompanyPage";
import NonverifyFundManagers from "./Components/Admin/NonVerifyFundManagers";
import NonverifyFundManagerPage from "./Components/Admin/NonVerifyFundManagerPage";
import Nonverifycorporate from "./Components/Admin/Corporate/NonVerifiedCorporates";
import NonverifycorporatePage from "./Components/Admin/Corporate/NonverifycorporatePage";
import Notifications from "./Components/Admin/Notifications";
import AdminCoporate from "./Components/Admin/Corporate";
import AdminCoporateRegister from "./Components/Admin/Corporate/Register";

import ValuationResponse from "./Components/Admin/ValuationResponses";
import ValuationResponsePage from "./Components/Admin/ValuationResponses/ReponsesPage";
import AdminAcademia from "./Components/Admin/Academia";
import LatestNews from "./Components/Admin/LatestNews";
import Platformupdates from "./Components/Admin/Platformupdates";
import UserActivity from "./Components/Admin/UserActivity";
import AdminPitcdeck from "./Components/Admin/Pitchdeck";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AdminContentLogin from "./Components/AdminContent";
import AdminContentDashboard from "./Components/AdminContent/dashboard";
import Allarticles from "./Components/AdminContent/Articles";
import UploadArticles from "./Components/AdminContent/UploadArticle";
import Sales from "./Components/Admin/SalesActivity";
import AllCorporates from "./Components/Admin/Corporate/AllCorporates";
import AllFunds from "./Components/Admin/Funds/AllFunds";
import AdminFunds from "./Components/Admin/Funds";
import AdminFundRegister from "./Components/Admin/Funds/Register";

function App() {
  return (
    <div className="App">
      <ToastContainer />
      <Router>
        <ProvideAuth>
          <Routes>
            {/* Login — no sidebar */}
            <Route exact path="/" element={<AdminLogin />} />

            {/* All admin routes — with sidebar */}
            <Route
              exact
              path="/zr-admin-dashboard"
              element={<AdminLayout><AdminDashboard /></AdminLayout>}
            />
            <Route
              exact
              path="/admin/verify-founder"
              element={<AdminLayout><NonVerifyFounders /></AdminLayout>}
            />
            <Route
              exact
              path="/admin/verify-investor"
              element={<AdminLayout><NonVerifyInvestors /></AdminLayout>}
            />
            <Route
              exact
              path="/admin/all-investors"
              element={<AdminLayout><AllInvestors /></AdminLayout>}
            />
            <Route
              exact
              path="/admin/verifyfounder/:founder"
              element={<AdminLayout><NonverifyFounderPage /></AdminLayout>}
            />
            <Route
              exact
              path="/admin/verify-investor/:investor"
              element={<AdminLayout><NonverifyInvestorPage /></AdminLayout>}
            />
            <Route
              exact
              path="/admin/verify-fundcompany"
              element={<AdminLayout><NonverifyFundCompanies /></AdminLayout>}
            />
            <Route
              exact
              path="/admin/verify-fundmanager"
              element={<AdminLayout><NonverifyFundManagers /></AdminLayout>}
            />
            <Route
              exact
              path="/admin/verify-fundcompany/:fundcompany"
              element={<AdminLayout><NonverifyFundCompanyPage /></AdminLayout>}
            />
            <Route
              exact
              path="/admin/verify-fundmanager/:fundmanager"
              element={<AdminLayout><NonverifyFundManagerPage /></AdminLayout>}
            />
            <Route
              exact
              path="/admin/verify-corporate"
              element={<AdminLayout><Nonverifycorporate /></AdminLayout>}
            />
            <Route
              exact
              path="/admin/verify-corporate/:corporate"
              element={<AdminLayout><NonverifycorporatePage /></AdminLayout>}
            />
            <Route
              exact
              path="/admin/notification"
              element={<AdminLayout><Notifications /></AdminLayout>}
            />
            <Route
              exact
              path="/admin/pitchdeck"
              element={<AdminLayout><AdminPitcdeck /></AdminLayout>}
            />
            <Route
              exact
              path="/admin/valuation"
              element={<AdminLayout><ValuationResponse /></AdminLayout>}
            />
            <Route
              exact
              path="/admin/valuations/user"
              element={<AdminLayout><ValuationResponsePage /></AdminLayout>}
            />
            <Route
              exact
              path="/admin/corporate"
              element={<AdminLayout><AdminCoporate /></AdminLayout>}
            />
            <Route
              exact
              path="/admin/corporate/register/:userid"
              element={<AdminLayout><AdminCoporateRegister /></AdminLayout>}
            />
            <Route
              exact
              path="/admin/all-corporates"
              element={<AdminLayout><AllCorporates /></AdminLayout>}
            />
            <Route
              exact
              path="/admin/all-funds"
              element={<AdminLayout><AllFunds /></AdminLayout>}
            />
            <Route
              exact
              path="/admin/funds"
              element={<AdminLayout><AdminFunds /></AdminLayout>}
            />
            <Route
              exact
              path="/admin/fund/register/:userid"
              element={<AdminLayout><AdminFundRegister /></AdminLayout>}
            />
            <Route
              exact
              path="/admin/academia"
              element={<AdminLayout><AdminAcademia /></AdminLayout>}
            />
            <Route
              exact
              path="/admin/latestNews"
              element={<AdminLayout><LatestNews /></AdminLayout>}
            />
            <Route
              exact
              path="/admin/platformupdates"
              element={<AdminLayout><Platformupdates /></AdminLayout>}
            />
            <Route
              exact
              path="/admin/user-activity"
              element={<AdminLayout><UserActivity /></AdminLayout>}
            />
            <Route
              exact
              path="/admin/sales"
              element={<AdminLayout><Sales /></AdminLayout>}
            />

            {/* Content admin routes — also with sidebar */}
            <Route
              exact
              path="/content-admin"
              element={<AdminLayout><AdminContentLogin /></AdminLayout>}
            />
            <Route
              exact
              path="/content-admindashboard"
              element={<AdminLayout><AdminContentDashboard /></AdminLayout>}
            />
            <Route
              exact
              path="/article-upload"
              element={<AdminLayout><UploadArticles /></AdminLayout>}
            />
            <Route
              exact
              path="/all-articles"
              element={<AdminLayout><Allarticles /></AdminLayout>}
            />
          </Routes>
        </ProvideAuth>
      </Router>
    </div>
  );
}

export default App;